module.exports = __webpack_public_path__ + "static/voxxed-9cb56d63419eb0c6db74f5e926208102.png";